
import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import NumberFormat from "react-number-format";
import {Timeline, TimelineEvent} from 'react-event-timeline'

class CrmUser extends React.Component
{
    constructor(props) {
        super(props);
        this.renderResults = this.renderResults.bind(this);
        this.handleIgnoreChange = this.handleIgnoreChange.bind(this);
        //this.renderModalDetails = this.renderModalDetails.bind(this);
        //this.setCurrentPromoUser = this.setCurrentPromoUser.bind(this);
        this.showCancelPreview = this.showCancelPreview.bind(this);
        this.resendEmailPromo = this.resendEmailPromo.bind(this);
        this.freeCode = this.freeCode.bind(this);
        this.state = {
            user: {},
            promos: [],
            currentPromoUser: {},
            modalUrl: "",
            showMailButton: true,
            eventos: []
        };
    }

    componentWillMount()
    {
        let self = this;
        axios.get('/api/crm/user/' + id_user)
            .then(response => {
                let user = response.data.user;
                let promos = response.data.promos;

                self.setState({
                    user: user,
                    promos: promos
                });
            })
            .catch(error => {
                if (typeof error.response.data !== 'undefined') {
                    let error_response = error.response.data;

                    switch (error_response) {
                        case "no_id_registered":
                            swal({
                                title: "¡Oh no!",
                                text: "Usuario no registrado",
                                icon: "warning",
                                closeOnClickOutside: false,
                                buttons: false,
                            });
                            break;
                        default:
                            swal({
                                title: "¡Oh no!",
                                text: "Ha ocurrido un error al procesar tu solicitud",
                                icon: "warning",
                            });
                            break;
                    }
                }
            });
    }

    componentDidMount()
    {
    }

    renderResults(item)
    {
        return(
            <tr key={item.id}>
                <td>{item.created_at}</td>
                <td>{item.tdc}</td>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.promo}</td>
                <td>{item.birthday}</td>
                <td>{item.month_promo}</td>
                <td>
                    <button className="btn btn-info" onClick={this.setCurrentPromoUser.bind(this, item)}>
                        <i className="fa fa-info-circle"></i> Detalles
                    </button>
                </td>
            </tr>
        );
    }

    getUserEvents()
    {
        let self = this;

        axios.get('/api/crm/events/' + id_user)
            .then(response => {
                let eventos = [];
                self.setState({
                    eventos: eventos
                });

                eventos = response.data;
                self.setState({
                    eventos: eventos
                });
            })
            .catch(error => {
            });

    }

    setCurrentPromoUser(item)
    {
        let self = this;
        let url = "/crm/mail_preview/" + item.promo + '/' + item.id;

        self.setState({
            currentPromoUser: item,
            modalUrl: url,
            showMailButton: true
        });

        self.getUserEvents();

        $('#promo_user_detailsModal').modal('show');
    }

    changeModalUrl(flag)
    {
        let self = this;
        
        if (flag === 'code') {
            let user = self.state.currentPromoUser.supplier_ws_response;

            self.setState({
                modalUrl: user,
                showMailButton: false
            });

            axios.post('/api/crm/events/' + id_user + '/1')
                .then(response => {
                })
                .catch(error => {
                });

        } else if (flag === 'mail') {
            let url = "/crm/mail_preview/" + self.state.currentPromoUser.promo + '/' + self.state.currentPromoUser.id;

            self.setState({
                modalUrl: url,
                showMailButton: true
            });

            axios.post('/api/crm/events/' + id_user + '/2')
                .then(response => {
                })
                .catch(error => {
                });
        }
    }

    showCancelPreview()
    {
        swal({
            title: "¿Estás seguro que deseas anular este registro?",
            text: "Ésta acción no podrá deshacerse en el futuro.",
            icon: "warning",
            dangerMode: true,
            buttons: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    swal({
                        text: "Procesando solicitud, espere un momento.",
                        buttons: false,
                        closeOnClickOutside: false
                    });
                    axios.get('/api/crm/cancel/' + id_user)
                        .then(response => {
                            location.reload();
                        })
                        .catch(error => {
                            swal("¡Ha ocurrido un error!", {
                                icon: "warning",
                            });
                        });
                }
            });
    }

    resendEmailPromo()
    {
        swal({
            text: "Enviando correo, por favor espere.",
            buttons: false,
            closeOnClickOutside: false
        });

        let email2 = $('#alternateEmail').val();

        let request = this.state.currentPromoUser;
        request['alternateEmail'] = email2;

        axios.get('/api/crm/mail/' + request['id'] + '/' + email2, this.state.currentPromoUser)
            .then(response => {
                swal({
                    title: "¡Ok!",
                    text: "Hemos enviado el correo de esta promoción.",
                    icon: "success",
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "No se han obtenido resultados.",
                    icon: "warning",
                });
            });
    }

    freeCode()
    {
        let freeUser = this.state.currentPromoUser;

        axios.put('/api/crm/free/', freeUser)
            .then(response => {
                swal({
                    title: "¡Ok!",
                    text: "Se ha liberado el código de promoción para éste usuario.",
                    icon: "success",
                });
            })
            .catch(error => {
                let error_type = error.response.data;

                if (error_type === 'already_free') {
                    swal({
                        title: "¡Oh no!",
                        text: "El código de promoción para éste usuario ya ha sido liberado.",
                        icon: "warning",
                    });
                } else {
                    swal({
                        title: "¡Oh no!",
                        text: "Ha ocurrido un error al liberar el código de promoción para éste usuario.",
                        icon: "danger",
                    });
                }
            });
    }

    handleIgnoreChange()
    {

    }

    renderUserEvents(item)
    {
        let icon = "";
        let iconColor = "";

        switch (item.type_action) {
            case '0':
                icon = "fa fa-user";
                iconColor = "#00A388";
                break;
            case '1':
                icon = "fa fa-ticket";
                iconColor = "#FFBB59";
                break;
            case '2':
                icon = "fa fa-envelope";
                iconColor = "#105187";
                break;
            case '3':
                icon = "fa fa-send";
                iconColor = "#3A9342";
                break;
            case '5':
                icon = "fa fa-send";
                iconColor = "#105187";
                break;
            case '6':
                icon = "fa fa-remove";
                iconColor = "#FF3830";
                break;
        }

        return(
            <TimelineEvent createdAt={item.created_at}
                           icon={<i className={icon}></i>}
                           iconColor={iconColor}
                           container={"card"}
                           cardHeaderStyle={{ background: "#FF9300", fontSize: "larger" }}>
                <h4>{item.action}</h4>
            </TimelineEvent>
        );
    }

    render()
    {
        return (
            <div>
                <div className="modal fade" tabIndex="-1" role="dialog" id="promo_user_detailsModal">
                    <div className="modal-dialog modal-full">
                        <div className="modal-content">
                            <div className="modal-header" style={{ borderBottomWidth: "0 !important", borderBottom: "none !important", padding: "0 !important", paddingBottom: "0 !important"}}>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h3>
                                            Preview
                                        </h3>
                                        <iframe className="rewards-frame" frameBorder="no" style={{ width: "100%", height: "650px" }}
                                                src={this.state.modalUrl}>
                                        </iframe>
                                    </div>
                                    <div className="col-md-3">
                                        <h3>
                                            Acciones
                                        </h3>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <button className={"btn btn-lg " + (!this.state.showMailButton? 'btn-warning': 'btn-white') + ' btn-block'}
                                                                onClick={this.changeModalUrl.bind(this, 'code')}>
                                                            <i className="fa fa-ticket"></i> Ver código
                                                        </button>
                                                    </div>
                                                    <br className="hidden-lg"/>
                                                    <br className="hidden-lg"/>
                                                    <div className="col-md-6">
                                                        <button className={"btn btn-lg " + (this.state.showMailButton? 'btn-primary' : 'btn-white') + ' btn-block'}
                                                                onClick={this.changeModalUrl.bind(this, 'mail')}>
                                                            <i className="fa fa-envelope-o"></i> Ver correo
                                                        </button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <button className={"btn btn-lg btn-info btn-block"} style={{ marginTop: "10px" }}
                                                                onClick={this.freeCode.bind(this, 'mail')}>
                                                            <i className="fa fa-check"></i> Liberar código
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <hr/>
                                                        <form id="resendEmailPromo" role="form">
                                                            <div className="form-group">
                                                                <h4>Correo alterno *</h4>
                                                                <input className="form-control input-lg" type="text" id="alternateEmail"/>
                                                            </div>
                                                            <button type="button" className="btn btn-info btn-lg waves-effect waves-light"
                                                                    onClick={this.resendEmailPromo}>
                                                                <i className="fa fa-send"></i> Reenviar
                                                            </button>
                                                        </form>
                                                        <br/>
                                                        <p>
                                                            * Si no se escribe un correo alterno, solo se enviará al correo registrado: <strong className="text-danger">{this.state.currentPromoUser.email}</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="col-md-12" style={{ position: "relative" }}>
                                                    <hr/>
                                                    <button type="button" className="btn btn-danger btn-xs waves-effect waves-light"
                                                            onClick={this.showCancelPreview}>
                                                        <i className="fa fa-warning"></i> Anular registro
                                                    </button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <h3>
                                            Eventos registrados
                                        </h3>
                                        <div style={{ height: "650px", overflowY: "auto" }}>
                                            <Timeline>
                                                {this.state.eventos.map(this.renderUserEvents.bind(this))}
                                            </Timeline>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-7 col-xs-12">
                                            <h3>Detalles de usuario</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label>Tarjeta/Folio</label>
                                            <input className="form-control" value={this.state.user.tdc} disabled={true}
                                                   onChange={this.handleIgnoreChange}/>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Nombre</label>
                                            <input className="form-control" value={this.state.user.name} disabled={true}
                                                   onChange={this.handleIgnoreChange}/>
                                        </div>
                                        <div className="col-md-2">
                                            <br/>
                                            <a href={'/crm'}>
                                                <button className="btn btn-info form-control"
                                                        style={{ marginTop: "5px" }}>
                                                    <i className="fa fa-refresh"></i> Nueva búsqueda
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-7 col-xs-12">
                                            <h3>Detalle de redención</h3>
                                        </div>
                                    </div>
                                    <table className="table table-striped m-0">
                                        <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Tarjeta/Folio</th>
                                            <th>Nombre</th>
                                            <th>Correo electrónico</th>
                                            <th>Promoción</th>
                                            <th>Fec. Nac.</th>
                                            <th>Mes Promo</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.promos.map(this.renderResults)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CrmUser;

if (document.getElementById('crm_user-component')) {
    ReactDOM.render(<CrmUser />, document.getElementById('crm_user-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/crm/CrmUser.jsx